export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa5b7de733cbbf49ad327b96c82818e7788453560&name=fetchTypeahead!'